import api from '../utils/api';

const getConversations = ({ teamId, clientId }) => {
  return api.get('/chat/conversations', {
    params: { team_id: teamId, client_id: clientId }
  });
};

const getMessages = ({ conversationId, teamId, clientId }) => {
  return api.get(`/chat/conversations/${conversationId}/messages`, {
    params: { team_id: teamId, client_id: clientId }
  });
};

const postAnswer = (payload) => {
  console.debug('[AI CHAT] request payload', payload);
  return api.post('/chat/answer', payload).catch((error) => {
    const status = error?.response?.status;
    const data = error?.response?.data;
    console.error('[AI CHAT] response error', { status, data });
    throw error;
  });
};

export { getConversations, getMessages, postAnswer };
